import { CSP_NONCE, enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { addIcons } from 'ionicons';
import { informationCircle } from 'ionicons/icons';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

addIcons({
  'information-circle': informationCircle,
});

const cspNonce = document
  .querySelector('meta[name="CSP_NONCE"]')
  ?.getAttribute('content')
  ?.trim();

const nonceProviders = cspNonce
  ? [{ provide: CSP_NONCE, useValue: cspNonce }]
  : [];

platformBrowserDynamic(nonceProviders)
  .bootstrapModule(AppModule)
  .catch(err => console.log(err));
